import { Accordion, Col, Container, Row } from "react-bootstrap";

const Faq= () => {
  return (
    <Container className="faq-section margin-bottom-70">
        <Row>
            <Col md="12">
                <h2 className="text-center">FAQs</h2>
                <p>
                    Read the following frequently asked questions to hire developers in India, understand  how we operate and how you can employ them.
                </p>
                <Accordion defaultActiveKey="0">
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>How can I hire developers?</Accordion.Header>
                        <Accordion.Body>
                            Hiring developers with us is simple and flexible. You can start by contacting us through our website or email with your project requirements. We'll discuss your goals, suggest the right developer(s) based on your needs, and set up an engagement model—whether it's full-time, part-time, or hourly. Once everything is finalized, your selected developer(s) can start working on your project right away.
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header>What is the cost of hiring developers?</Accordion.Header>
                        <Accordion.Body>
                            The cost of hiring developers depends on several factors, including the developer’s experience level, the technology stack, the scope of your project, and the engagement model (hourly, part-time, or full-time). We offer flexible pricing to suit different project sizes and budgets. Contact us with your requirements, and we’ll provide a detailed quote tailored to your needs.
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                        <Accordion.Header>Do you sign an NDA?</Accordion.Header>
                        <Accordion.Body>
                            Yes, absolutely. We understand the importance of confidentiality and are happy to sign a Non-Disclosure Agreement (NDA) before discussing your project in detail. Your ideas, data, and business information will remain secure and private throughout our engagement.
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3">
                        <Accordion.Header>How can I communicate with my developer?</Accordion.Header>
                        <Accordion.Body>
                            You can communicate directly with your assigned developer through your preferred channels such as email, Slack, Zoom, Skype, or other project management tools like Trello, Jira, or Asana. We ensure smooth and regular communication to keep you updated on the project’s progress and to quickly address any questions or feedback.
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="4">
                        <Accordion.Header>How do you help businesses in fulfilling development needs?</Accordion.Header>
                        <Accordion.Body>
                            We partner with businesses to provide end-to-end development solutions tailored to their goals. Whether you need a dedicated developer, a full development team, or help with a specific project, we offer flexible engagement models. Our experienced developers specialize in various technologies and work closely with you to deliver high-quality, scalable, and efficient solutions—on time and within budget. From planning and design to development and ongoing support, we ensure your technical needs are fully covered.
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="5">
                        <Accordion.Header>How do you protect your client's IP and data?</Accordion.Header>
                        <Accordion.Body>
                            We take intellectual property (IP) and data security very seriously. To ensure full protection:
                            <ul>
                                <li>
                                    We sign Non-Disclosure Agreements (NDAs) before starting any project.
                                </li>
                                <li>
                                    All IP rights are transferred to you upon project completion.
                                </li>
                                <li>
                                    Our team follows strict internal security protocols and uses secure communication channels.
                                </li>
                                <li>
                                    Access to project data is limited to authorized personnel only.
                                </li>
                                <li>
                                    We use version control and encrypted storage to safeguard your code and assets.
                                </li>
                            </ul>

                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="6">
                        <Accordion.Header>Do you offer flexible options for hiring developers?</Accordion.Header>
                        <Accordion.Body>
                            Yes, we offer flexible hiring models to suit your project requirements and budget. You can hire developers on a full-time, part-time, or hourly basis. Whether you need a single developer or an entire team, we can customize the engagement to match your workload, timeline, and business goals. This flexibility ensures you get the right support exactly when you need it.
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="7">
                        <Accordion.Header>How can potential clients get started?</Accordion.Header>
                        <Accordion.Body>
                            Getting started is simple! Just reach out to us through our website’s contact form, email, or phone. Share your project requirements or ideas, and our team will schedule a free consultation to understand your goals and suggest the best approach. Once everything is aligned, we’ll finalize the terms and assign the right developer or team to kick off your project.
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </Col>
        </Row>
    </Container>
  );
}

export default Faq;